export const DOCUMENT_ROOT = 'document/';

// Actions types
export const UPLOAD_CLICKED = 'uploadClicked';
export const UPLOAD_MISSING_DOC = 'uploadMissingDoc';
export const UPLOAD_DOCUMENT = 'uploadDocument';
export const DELETE_DOCUMENT = 'deleteDocument';
export const DOWNLOAD_DOCUMENT = 'getDocumentContent';
export const GET_DOCUMENT_LIST = 'getDocumentList';
export const GET_MISSING_DOCUMENT_LIST = 'getMissingDocumentList';

// Getters types
export const DOCUMENTS = 'documents';
export const MISSING_DOCUMENTS = 'missingDocuments';
export const REMOVE_MISSING_DOCUMENT_FLAG = 'removeMissingDocumentsFlag';
export const DOCUMENTS_LIST = 'getFormDocumentsList';
export const DOCUMENTS_ERRORS = 'documentsErrors';
export const LOADING = 'loading';

// Mutations types
export const SET_DOCUMENTS = 'setDocuments';
export const SET_MISSING_DOCUMENTS = 'setMissingDocuments';
export const ADD_DOCUMENT = 'addDocument';
export const REMOVE_DOCUMENT = 'removeDocument';
export const REMOVE_DIRTY_DOCUMENT = 'REMOVE_DIRTY_DOCUMENT';
export const SET_LOADING = 'setLoading';
export const SET_DOCUMENTS_ERRORS = 'setDocumentsErrors';
export const SET_REMOVE_MISSING_DOCUMENT_FLAG = 'setRemoveMissingDocumentsFlag';
export const SET_UPLOAD_MISSING_DOCUMENT_FLAG = 'setUploadMissingDocumentsFlag';
